import type React from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUrlHash } from "../../components/navigation/URL";
import { useSelectedCompany } from "../../hooks/useCompany";
import { useProfile } from "../../hooks/useProfile";
import { useSelectedScheme } from "../../hooks/useScheme";
import { usePrivacyMode } from "../../reducers/privacy";

export default function AdminLandingPage(): React.ReactElement {
  const location = useLocation();
  const navigate = useNavigate();
  const userProfile = useProfile();

  const hash = getUrlHash(
    useSelectedCompany(),
    useSelectedScheme(),
    usePrivacyMode(),
  );
  const search = location.search;

  useEffect(() => {
    if (location.pathname === "/admin" || location.pathname === "/admin/") {
      if (userProfile?.user_type === "superadmin") {
        navigate({ pathname: "/admin/company", hash: hash, search: search });
      } else {
        navigate({ pathname: "dashboard", hash: hash, search: search });
      }
    }
  }, [navigate, hash, search, location, userProfile]);

  return <></>;
}
